import _ from "lodash";

export class DoorModel {

    constructor(options) {
        this._position = options.position;
        this._preview = options.preview;
        this._type = options.type;
        this._points = options.points;

        this._selectedProduct = null;
        this._selectedProfile = null;
        this._selectedColourRange = null;
        this._selectedColour = null;
        this._selectedOptions = [];

        this._selections = [];
    }

    setPreview(preview) {
        this._preview = preview;
    }

    getPreview() {
        return this._preview;
    }

    setType(type) {
        this._type = type;
    }

    getType() {
        return this._type;
    }

    setPoints(points) {
        this._points = points;
    }

    getPoints() {
        return this._points;
    }

    setProduct(product) {
        this._selectedProduct = product;

        // default profile
        if (product && product.profiles.length) {
            this.setProfile(product.profiles[0]);
        } else {
            this.setProfile(null);
        }

        this.setSelections();

    }

    getProduct() {
        return this._selectedProduct;
    }

    setProfile(profile) {

        this._selectedProfile = profile;

        // default colour range
        if (profile && profile.colour_ranges.length) {
            this.setColourRange(profile.colour_ranges[0]);
        } else {
            this.setColourRange(null);
        }

        // setup the options for the selected profile and default to first value
        this._selectedOptions = _.flatten(_.map(profile.options, (option) => {

            let items = [];

            items.push({
                option: option,
                selectedValue: option.values.length ? option.values[0] : null
            });

            return items;

        }));

        this.setSelections();
    }

    getProfile() {
        return this._selectedProfile;
    }

    setColourRange(colourRange) {
        this._selectedColourRange = colourRange;

        // default colour
        if (colourRange && colourRange.colours.length) {
            this.setColour(colourRange.colours[0]);
        } else {
            this.setColour(null);
        }

        this.setSelections();
    }

    getColourRange() {
        return this._selectedColourRange;
    }

    setColour(colour) {
        this._selectedColour = colour;

        this.setSelections();
    }

    getColour() {
        return this._selectedColour;
    }

    getOptions() {
        return this._selectedOptions;
    }

    getOption(option) {
        return _.find(this._selectedOptions, {option: option});
    }

    getSubOption(subOption) {

        return _.find(_.flatten(_.map(this._selectedOptions, 'selectedSubOptions')), {option: subOption});
    }

    // sets the value of an option and defaults any sub option values
    setOptionValue(option, value) {

        let _option = this.getOption(option);

        if (!_option) return;

        _option.selectedValue = value;

        _option.selectedSubOptions = _.flatten(_.map(_option.selectedValue.sub_options, (option) => {

            let items = [];

            items.push({
                option: option,
                selectedValue: option.values.length ? option.values[0] : null,
                selectedColour: option.colours.length ? option.colours[0] : null
            });

            return items;

        }));

        this.setSelections();

    }

    setOptionColourValue(option, value) {

        let _option = this.getOption(option);

        if (!option) return;

        _option.selectedColour = value;

        this.setSelections();

    }

    setSubOptionValue(subOption, value) {

        let _subOption = this.getSubOption(subOption);

        if (!_subOption) return;

        _subOption.selectedValue = value;

        this.setSelections();

    }

    setSubOptionColourValue(subOption, value) {

        let _subOption = this.getSubOption(subOption);

        if (!_subOption) return;

        _subOption.selectedColour = value;

        this.setSelections();

    }

    getOptionValue(option) {
        return this.getOption(option).selectedValue;
    }

    getSubOptionValue(subOption) {
        return this.getSubOption(subOption).selectedValue;
    }

    getSubOptionColour(subOption) {
        return this.getSubOption(subOption).selectedColour;
    }

    setSelections() {

        let selections = [];

        if (this._selectedProduct) {

            let product = {
                type: 'product',
                heading: 'Product',
                label: this._selectedProduct.label,
                data: this._selectedProduct,
                info: this._selectedProduct.description
            };

            if (this._selectedProfile) {
                product.sub_items = [{
                    type: 'profile',
                    heading: 'Profile',
                    label: this._selectedProfile.label,
                    data: this._selectedProfile,
                    info: this._selectedProfile.description,
                    disabled: this._selectedProduct.profiles.length <= 1
                }];
            }

            selections.push(product);
        }

        if (this._selectedColourRange) {

            let colourRange = {
                type: 'colour_range',
                heading: 'Colour Range',
                label: this._selectedColourRange.label,
                data: this._selectedColourRange,
                info: this._selectedColourRange.description,
                disabled: this._selectedProfile.colour_ranges.length <= 1
            };

            if (this._selectedColour) {
                colourRange.sub_items = [
                    {
                        type: 'colour',
                        heading: 'Colour',
                        label: this._selectedColour.label,
                        data: this._selectedColour,
                        info: this._selectedColour.description,
                        disabled: this._selectedColourRange.colours.length <= 1
                    }
                ];
            }

            selections.push(colourRange);
        }

        if (this._selectedOptions) {

            this._selectedOptions.forEach((option) => {

                if (option.selectedValue) {

                    selections.push({
                        type: 'option',
                        heading: option.option.label,
                        label: option.selectedValue.label,
                        data: option.selectedValue,
                        parent: option.option,
                        info: option.selectedValue.description,
                        disabled: option.option.values.length <= 1,
                        sub_items: _.flatten(_.map(option.selectedSubOptions, (subOption) => {

                            if (subOption.selectedValue) {

                                let items = [];

                                items.push({
                                    type: 'sub_option',
                                    heading: subOption.option.label,
                                    label: subOption.selectedValue.label,
                                    data: subOption.selectedValue,
                                    parent: subOption.option,
                                    info: subOption.selectedValue.description,
                                    disabled: subOption.option.values.length <= 1
                                });

                                if (subOption.selectedColour) {

                                    items.push({
                                        type: 'sub_option_colour',
                                        heading: subOption.option.label + ' Colour',
                                        label: subOption.selectedColour.label,
                                        data: subOption.selectedColour,
                                        parent: subOption.option,
                                        info: subOption.selectedColour.description,
                                        disabled: subOption.option.values.length <= 1
                                    });

                                }

                                return items;

                            }

                        }))
                    });

                }

            });

        }

        this._selections = selections;

    }

    getSelections() {

        return this._selections;

    }

    getConfig() {

        if (!this._selectedProduct) return null;

        return {
            type: this._type,
            points: this._points,
            product_id: this._selectedProduct ? this._selectedProduct.id : null,
            profile_id: this._selectedProfile ? this._selectedProfile.id : null,
            colour_range_id: this._selectedColourRange ? this._selectedColourRange.id : null,
            colour_id: this._selectedColour ? this._selectedColour.id : null,
            options: _.map(this._selectedOptions, (option) => {

                return {
                    id: option.option.id,
                    value: option.selectedValue ? option.selectedValue.id : null,
                    sub_options: _.map(option.selectedSubOptions, (subOption) => {

                        return {
                            id: subOption.option.id,
                            value: subOption.selectedValue ? subOption.selectedValue.id : null,
                            colour: subOption.selectedColour ? subOption.selectedColour.id : null,
                        };

                    })
                };

            })
        };

    }

}



// WEBPACK FOOTER //
// ./src/js/door-model.js